import { RegistryItem } from "@schemas/calculationmethods/schema";
import { CalculationMethodType } from "__generated__/graphql";
import TimeUnitCalculationMethodForm from "view/calculationmethods/components/form/TimeUnitCalculationMethodForm";
import TimeUnitCalculationMethodDetails from "view/calculationmethods/components/details/TimeUnitCalculationMethodDetails";

export const TimeUnitSchema: RegistryItem = {
	[CalculationMethodType.TimeUnit]: {
		Form: TimeUnitCalculationMethodForm,
		Details: TimeUnitCalculationMethodDetails,
		fields: {
			"calculationMethod.timeUnit": { path: "timeUnit", rules: { required: true } },
			"calculationMethod.price": { path: "price", rules: { required: true } },
		},
		toInput: (form) => ({
			timeUnitCalculationMethodInput: {
				id: form.id,
				timeUnit: form.timeUnit,
				minimumTimeUnitsPayable: form.minimumTimeUnitsPayable,
				price: form.price,
			},
		}),
		toForm: (method) => ({
			timeUnit: method.timeUnit ?? undefined,
			minimumTimeUnitsPayable: method.minimumTimeUnitsPayable ?? undefined,
		}),
	},
};
